module.exports = __webpack_public_path__ + "static/media/14UNEP11.4476089c.jpg";